<template>
  <div
    class="ws-main pb-120"
  >
    <WsTitle>批次匯出內規</WsTitle>
    <v-stepper
      v-model="step"
      class="elevation-0 transparent"
    >
      <v-stepper-header class="elevation-0">
        <v-stepper-step
          step="1"
          editable
        >選擇分段依據</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          step="2"
          editable
        >匯入來源</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          step="3"
          editable
        >編輯內容</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="mt-5">
        <v-stepper-content
          step="1"
          class="pa-0"
        >
        <ValidationObserver ref="ValidationObserverStep1">
          <WsCard>
            <div class="ws-content" :style="{'min-height':'700px'}">
              <v-row>
                <v-col
                  sm="3"
                  cols="12"
                >
                  <WsState
                    v-model="firstRegex.value"
                    type="select"
                    label="章解析類型"
                    :items="firstRegex.items"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  sm="3"
                  cols="12"
                >
                  <WsState
                    v-model="secondRegex.value"
                    type="select"
                    label="節解析類型"
                    :items="secondRegex.items"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  sm="3"
                  cols="12"
                >
                  <WsState
                    v-model="thirdRegex.value"
                    type="select"
                    label="條解析類型"
                    :items="thirdRegex.items"
                  />
                </v-col>
              </v-row>
            </div>
          </WsCard>
        </ValidationObserver>
        </v-stepper-content>
        <v-stepper-content
          step="2"
          class="pa-0"
        >
        <ValidationObserver ref="ValidationObserverStep2">
          <WsCard>
            <div class="ws-content" >
              <WsState
                v-model="rawContent"
                required
                label="原文"
                type="textarea"
                rules="required"
              />
            </div>
          </WsCard>
        </ValidationObserver>
        </v-stepper-content>
        <v-stepper-content step="3">
          <div v-if="isLoading.parse">
            <v-skeleton-loader
              v-for="n in 3"
              :key="`skeleton-${n}`"
              type="list-item-three-line"
              :tile="true"
              class="mt-5"
            ></v-skeleton-loader>
          </div>
          <WsCard v-else v-for="(item,index) in parseContent" :key="index" class="mb-20 pa-20">
            <WsState
              v-model="item.name"
              type="text"
              label="名稱"
            />
            <WsState
              v-model="item.content"
              type="textarea"
              label="內容"
            />
          </WsCard>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <WsMainBottomNav>
      <WsBtn
        v-if="step !== 1"
        outlined
        color="textSecondary"
        @click="$_onPrevClick"
      >上一步</WsBtn>
      <WsBtn
        v-if="step !== 3"
        :loading="isLoading.parse"
        :disabled="isLoading.parse"
        @click="$_onNextClick"
      >下一步</WsBtn>
      <WsBtn
        v-if="step === 3"
        :loading="isLoading.submit"
        @click="$_onSubmit"
      >送出</WsBtn>
    </WsMainBottomNav>
    <WsAlertDialog
      ref="WsAlertDialog"
      btnText="確認"
      color="primary"
      title="編輯的內容會清除，確認要返回上一步嗎？"
      @submit="$_onClearParseContentAndSortList"
    />
  </div>
</template>

<script>
import { utils, writeFileXLSX } from 'xlsx';

export default {
  data() {
    return {
      isLoading: {
        submit: false,
        parse: false,
      },
      step: 1,
      firstRegex: {
        value: null,
        items: [
          {
            value: /(第 *[零一二三四五六七八九十百千]+ *[章])(.*)/,
            text: '第一章',
          },
          {
            value: /(第 *[\d-\d]+ *[章])(.*)/,
            text: '第1章',
          },
          {
            value: /([零壹貳參肆伍陸柒捌玖拾佰仟]+)、(.*)/,
            text: '壹、',
          },
        ],
      },
      secondRegex: {
        value: null,
        items: [
          {
            value: /(第 *[零一二三四五六七八九十百千]+ *[条])(.*)/,
            text: '第一节',
          },
          {
            value: /(第 *[\d-\d]+ *[节])(.*)/,
            text: '第1节',
          },
          {
            value: /^([0-9]\.[0-9])\s+(.*)/,
            text: '1.1',
          },
        ],
      },
      thirdRegex: {
        value: null,
        items: [
          {
            value: /([零一二三四五六七八九十百千]+)、(.*)/,
            text: '一、',
          },
          {
            value: /(第 *[零一二三四五六七八九十百千]+ *[条])(.*)/,
            text: '第一条',
          },
          {
            value: /(第 *[零一二三四五六七八九十百千]+ *[点])(.*)/,
            text: '第一点',
          },
          {
            value: /(第 *[\d-\d]+ *[條])(.*)/,
            text: '第1條',
          },
          {
            value: /(?<!\S)(第 *\s*[零一二三四五六七八九十百千]+ *\s*[條]之?[零一二三四五六七八九十百千]*)(?!\S)(.*)/,
            text: '第一條',
          },
          {
            value: /^([0-9]\.[0-9]\.[0-9])\s+(.*)/,
            text: '1.1.1',
          },
        ],
      },
      rawContent: '',
      parseContent: [],
    }
  },
  methods: {
    $_onPrevClick() {
      if (this.step !== 3) this.step--;
      else if (this.step === 3) this.$refs.WsAlertDialog.open();
    },
    async $_onNextClick() {
      if (this.step === 1) {
        const isValidate = await this.$refs.ValidationObserverStep1.validate();
        if (!isValidate) return;
      }
      if (this.step === 2) {
        const isValidate = await this.$refs.ValidationObserverStep2.validate();
        if (!isValidate) return;
        this.isLoading.parse = true;
        setTimeout(() => {
          this.parseContent = this.$_getParseArr(this.rawContent);
          this.isLoading.parse = false;
        }, 500);
      }
      this.step++;
    },
    $_onSubmit() {
      this.isLoading.submit = true;
      this.$_onExportXlsx(this.parseContent);
      this.isLoading.submit = false;
    },
    $_getParseArr(text) {
      if (!text) return [];
      const parseArr = [];
      const lineArr = text.match(/[^\r\n]+/g);
      const setParseItem = (matchArr, baseParseLine) => {
        return {
          ...baseParseLine,
          name: matchArr[1].trim(),
          content: matchArr[2].trim(),
        };
      };
      const insertParsedItem = (parsedLine) => {
        if (parseArr.length === 0) {
          parseArr.push(parsedLine);
          return;
        }
        let lastParse = parseArr[parseArr.length - 1];
        if (lastParse.name) parseArr.push(parsedLine);
        else lastParse = parsedLine;
      };
      const handleNoMatchLine = (line) => {
        if (parseArr.length === 0) return;
        const lastParse = parseArr[parseArr.length - 1];
        lastParse.content += `\n${line}`;
      };
      lineArr.forEach(rawLine => {
        const line = rawLine.trim();
        const baseParseLine = {
          name: '',
          content: line,
        };
        if (!this.firstRegex.value && !this.secondRegex.value && !this.thirdRegex.value) {
          handleNoMatchLine(line);
          return;
        }
        const firstMatch = this.firstRegex.value && line.match(this.firstRegex.value);
        const secondMatch = this.secondRegex.value && line.match(this.secondRegex.value);
        const thirdMatch = this.thirdRegex.value && line.match(this.thirdRegex.value);
        if (firstMatch) insertParsedItem(setParseItem(firstMatch, baseParseLine));
        else if (secondMatch) insertParsedItem(setParseItem(secondMatch, baseParseLine));
        else if (thirdMatch) insertParsedItem(setParseItem(thirdMatch, baseParseLine));
        else handleNoMatchLine(line);
      });
      return parseArr;
    },
    $_onExportXlsx(dataList) {
      const ws = utils.json_to_sheet(dataList);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");
      writeFileXLSX(wb, "SheetJSVueAoO.xlsx");
    },
    $_onClearParseContentAndSortList() {
      this.parseContent = [];
      this.$refs.WsAlertDialog.close();
      this.step--;
    },
  },
}
</script>